import { useQuery } from "@tanstack/react-query";
import { getHeadlineById } from "./api";
import useAuth from "@/hooks/useAuth";

export const useHeadlineById = (headlineId: number | null) => {
  const { authenticated } = useAuth();

  return useQuery({
    queryKey: ["headline", headlineId],
    queryFn: () => getHeadlineById(headlineId!),
    enabled: authenticated && headlineId !== null,
  });
};
